import React from 'react';
import AuthService from '../services/authService';
import {redirectTo} from '../util';

interface AuthContextType {
    from: string;
    login: (accountName: string, password: string) => Promise<boolean>;
    logout: () => void;
}

const AuthContext = React.createContext<AuthContextType>(null!);

const UseAuthContext = () => {
    return React.useContext(AuthContext);
};

const AuthProvider = ({children}: {children: React.ReactNode}) => {
    const login = async (accountName: string, password: string) => {
        const service = new AuthService();
        const isLogin = await service.login(accountName, password);

        return isLogin;
    };

    const logout = () => {
        sessionStorage.removeItem('jwt');
        redirectTo('/login');
    };

    const value: AuthContextType = {
        from: '/',
        login: login,
        logout: logout,
    };

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

const RequireAuth = ({children}: {children: JSX.Element}) => {
    const authService = new AuthService();

    const isAlivejwtPromise = authService.isAliveJwt();

    isAlivejwtPromise
        .then((isAlive) => {
            if (isAlive === false) {
                redirectTo('/login');
            }
        })
        .catch((reson) => {
            console.error(reson);
            redirectTo('/login');
        });

    return children;
};

export {AuthProvider, RequireAuth, UseAuthContext as useAuthContext};
